/**
 * HotelImages component.
 */
define([
    'jQuery',
    'library/fcse-compatibility/object',
    'library/fcse-component/optionsMixin',
    'library/fcse-events/eventDispatcher',
    'jquery-cycle2',
    'simplemodal'
    /*'library/jquery-touchswipe'*/
],
    function($, Object, OptionsMixin, EventDispatcher) {

        var HotelImages = function(options) {
            EventDispatcher.apply(this, arguments);

            // Set default options
            var defaultOptions = {
                elementSelector: '[data-fcse-role="gallery"]',
                zoomSelector: '[data-fcse-role="gallery--sliderzoom"]',
                containerSelector: '[data-fcse-role="gallery--slidercontainer"]',
                thumbsSelector: '[data-fcse-role="gallery--thumbcontainer"]',
                modalGallerySelector: '[data-fcse-role="gallery--modal"]',
                galleryNextSelector: '[data-fcse-role="btn-gallery-next"]',
                galleryPrevSelector: '[data-fcse-role="btn-gallery-prev"]',
                activeClass: 'is-active',
                hiddenClass: 'is-hidden',
                startingSlide: 0
            };

            this.element = null;
            this.zoomElement = null;
            this.containerElement = null;
            this.thumbsElement = null;
            this._hasVideos = 0;

            this._modalGalleryElement = null;

            this.addOptions(defaultOptions, options);

            this._init();
        };

        HotelImages.prototype = $.extend(Object.create(EventDispatcher.prototype), Object.create(OptionsMixin),{
            _init: function()
            {
                var self = this;
                this.element = this.option('element') || $(this.option('elementSelector'));

                if (this.element.length != 1) {
                    throw new Error('Only one element of type ' + this.option('elementSelector') +
                        ' is expected, ' + this.element.length + ' resolved.');
                }
                this._hasVideos = this.element.data('has-videos');
                this.zoomElement = $(this.option('zoomSelector'), this.element);
                this.containerElement = $(this.option('containerSelector'), this.element);
                this.thumbsElements = $(this.option('thumbsSelector'), this.element);
                this._initSlideShow();

                // Swipe support temporarily disabled
                /* this.element.swipe({
                    allowPageScroll: 'auto',
                    swipeLeft: function() {
                        if ($(self.option('galleryNextSelector'), self.element).is(':visible')) {
                            self.containerElement.cycle('next');
                        }
                    },
                    swipeRight: function() {
                        if ($(self.option('galleryPrevSelector'), self.element).is(':visible')) {
                            self.containerElement.cycle('prev');
                        }
                    }
                }); */
                /* swipe:function(event, direction, distance, duration, fingerCount, fingerData) {
                 if (direction === 'left' && $(self.option('galleryNextSelector'), self.element).is(':visible')) {
                 self.containerElement.cycle('next');
                 } else if (direction === 'right' && $(self.option('galleryPrevSelector'), self.element).is(':visible')) {
                 self.containerElement.cycle('prev');
                 }
                 } */
            },

            _initSlideShow: function()
            {
                var self = this;
                var isSafari = (
                    navigator.userAgent.indexOf('Safari') !== -1 &&
                    navigator.userAgent.indexOf('Chrome') === -1
                );

                const promises = [];
                $('img[data-src]', this.element).each(function(index, item) {
                    var $item = $(item);
                    const promise = new $.Deferred();
                    promises.push(promise);

                    var onLoad = function() {
                        $item.attr('data-img-loaded', 1);
                        $item.removeClass(self.option('hiddenClass'));
                        promise.resolve(item);
                    };
                    var onError = function() {
                        const parent = $item.parent();
                        if(parent.attr('data-index')) {
                            parent.remove();
                        } else {
                            $item.remove();
                        }
                        promise.resolve(item);
                    };

                    if (isSafari) {
                        var img = new Image();
                        img.addEventListener('load', onLoad, false);
                        img.addEventListener('error', onError, false);
                        img.src = $item.data('src');
                    } else {
                        item.onload = onLoad;
                        item.onerror = onError;
                    }
                    $item.attr('src', $item.data('src'));
                });
                // when all images did load, initialize slider
                $.when(...promises).then(() => {
                    self._check();
                    self._bindEventHandlers();
                    self._setActiveThumb(self.option('startingSlide'));
                    self._updateScrollControls(0);
                });
            },
            
            _check: function() {
                // recalculate indices and length (might have changed):
                const thumbs = $('[data-index]', this.thumbsElements);
                this._totalThumbs = thumbs.length;
                thumbs.each((index, item) => {
                    $(item).attr('data-index', index);
                });
                var self = this,
                    loaded = $('> img[data-img-loaded]', this.containerElement),
                    total = $('> img', this.containerElement);
                if (loaded.length !== total.length) {
                    return;
                }
                this.containerElement.cycle({startingSlide: self.option('startingSlide'), slides: '> *'});

                this.containerElement.on('cycle-before', function(event, opts){
                    self._setActiveThumb(opts.nextSlide);
                    self._updateScrollControls(opts.nextSlide);
                });
                if (_.isFunction(this.option('galleryInitCallback'))) {
                    this.option('galleryInitCallback')(this);
                }
            },

            _updateScrollControls: function(slideIndex) {
                var prevElement = $(this.option('galleryPrevSelector')).show();
                var nextElement = $(this.option('galleryNextSelector')).show();

                if (slideIndex === 0) {
                    prevElement.hide();
                } else if (slideIndex === this._totalThumbs - 1) {
                    nextElement.hide();
                }
            },

            _bindEventHandlers: function()
            {
                var self = this;
                var firstThumb = $('[data-index]:first', this.thumbsElements);
                var thumbWidth = firstThumb.outerWidth() + parseInt(firstThumb.css('margin-right'));
                var totalWidth = this._totalThumbs * thumbWidth;
                var imagesContainer = $('[data-fcse-role="gallery--thumbcontainer-images"]', this.thumbsElements);

                imagesContainer.width(totalWidth);

                this.zoomElement.off('click').on('click', function(){
                    // Disabled for now
                    // self._initModalSlideShow();
                });

                this.thumbsElements.on('click', '[data-index]', function(event) {
                    event.preventDefault();
                    self._setActiveSlide($(event.currentTarget).data('index'));
                });

                this.element.on('click', this.option('galleryNextSelector'), function(){
                    self.containerElement.cycle('next');
                    self.thumbsElements.animate({
                          scrollLeft: "+=" + thumbWidth + "px"
                      }
                      , function () {
                      });
                });

                this.element.on('click', this.option('galleryPrevSelector'), function(){
                    self.containerElement.cycle('prev');
                    self.thumbsElements.animate({
                          scrollLeft: "-=" + thumbWidth + "px"
                      }
                      , function () {
                      });
                });
            },

            _initModalSlideShow: function()
            {
                if (!this._modalGalleryElement) {
                    this._modalGalleryElement = $(this.option('modalGallerySelector'))
                        .removeClass("is-hidden").detach();
                }
                if (!this.containerElement.data("cycle.opts")) {
                    return;
                }
                var options = {
                    element: this._modalGalleryElement,
                    startingSlide: this.containerElement.data("cycle.opts").currSlide,
                    template: '<li class="gallery--thumb gallery--thumbsmall lightbox--thumbnailitem" data-index="$i"><img alt="" src="$src"></li>',
                    galleryInitCallback: function(gallery) {
                        var i, images = $('img', gallery.containerElement),
                            template = gallery.option('template'),
                            element;
                        if (_.isUndefined(template)) {
                            return;
                        }
                        gallery.thumbsElements.html('');
                        for (i = 0; i < images.length && i < 5; ++i) {
                            element = template.replace(/\$i/g, i).replace(/\$src/g, images[i].src);
                            gallery.thumbsElements.append(element);
                        }
                    }
                };
                new HotelImages(options).element.modal();
            },

            _setActiveThumb: function(index)
            {
                if ($.isNumeric(index)) {
                    $('[data-index]', this.thumbsElements).removeClass(this.option('activeClass'))
                        .filter('[data-index="' + index + '"]').addClass(this.option('activeClass'));
                }
            },

            _setActiveSlide: function(index)
            {
                if ($.isNumeric(index)) {
                    this.containerElement.cycle('goto', Number(index));
                }
            }
        });

        return HotelImages;
    }
);


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/hotelimages/hotelimages.js